<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal_size md_size">
                <a href="javascript:" class="ui_close" type="button" @click="$emit('close')">
                    <span class="sr_only"></span>
                </a>
                <dl class="modal_content">
                    <dt class="ellipsis">
                        <i>{{ $t('FIELD.INACTIVE.TITLE') }}</i>
                    </dt>
                    <dd>
                        <!-- detail_Authorization-->
                        <table class="create_table noLine">
                            <colgroup>
                                <col width="17%" />
                                <col width="*" />
                                <col width="17%" />
                                <col width="*" />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.SUBSIDIARY') }}</th>
                                    <td>{{ searchDeptNm }}</td>
                                    <th>{{ $t('FIELD.USER.NAME') }}</th>
                                    <td>{{ searchLoginName }}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.INQUIRY') }}</th>
                                    <td colspan="3" data-input-type="select">
                                        <fieldset class="ui_fieldset set_2">
                                            <label class="select-wrap">
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="inquiry1Code"
                                                    @change="inquiryList(2)"
                                                >
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in inquiry1CodeList"
                                                        :value="item.CD"
                                                        :key="pageName + item.CD"
                                                    >
                                                        {{ item.CD_NAME }}
                                                    </option>
                                                </select>
                                            </label>
                                            <label class="select-wrap">
                                                <select class="slt_white w100p" v-model="inquiry2Code">
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in inquiry2CodeList"
                                                        :value="item.CD"
                                                        :key="pageName + item.CD"
                                                    >
                                                        {{ item.CD_NAME }}
                                                    </option>
                                                </select>
                                            </label>
                                        </fieldset>
                                    </td>
                                </tr>
                                <tr>
                                    <th>{{ $t('FIELD.GLOBAL.CATEGORY') }}</th>
                                    <td colspan="3" data-input-type="select">
                                        <fieldset class="ui_fieldset set_3">
                                            <label class="select-wrap">
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="category1Code"
                                                    @change="categoryList(2)"
                                                >
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in category1CodeList"
                                                        :value="item.code"
                                                        :key="pageName + item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </label>
                                            <label class="select-wrap">
                                                <select
                                                    class="slt_white w100p"
                                                    v-model="category2Code"
                                                    @change="categoryList(3)"
                                                >
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in category2CodeList"
                                                        :value="item.code"
                                                        :key="pageName + item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </label>
                                            <label class="select-wrap">
                                                <select class="slt_white w100p" v-model="category3Code">
                                                    <option value="">{{ $t('FIELD.FAST.DURATION.ALL') }}</option>
                                                    <option
                                                        v-for="item in category3CodeList"
                                                        :value="item.code"
                                                        :key="pageName + item.code"
                                                    >
                                                        {{ item.codeName }}
                                                    </option>
                                                </select>
                                            </label>
                                        </fieldset>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <!-- Grid -->
                        <div class="grid_wrap mt-20">
                            <div class="grid_total">
                                {{ $t('TITLE.TOTAL.COUNT') }} <em>{{ gridData.length }}</em>
                            </div>
                            <!-- Grid -->
                            <toast-grid
                                :gridId="gridId"
                                :columns="columns"
                                :data="gridData"
                                :ref="gridId"
                                :key="gridKey"
                                :isTotalCount="false"
                                :options="options"
                                :pageOptions="pageOptions"
                            />
                        </div>
                        <!-- //grid -->
                    </dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import qs from 'query-string';
import Vue from 'vue';
import api from '@/service';
import axios from 'axios';
import store from '@/vuex/store';
import moment from 'moment';
import SDLUtil from '@/utils/SDLUtil';
import { mapActions, mapGetters } from 'vuex';

import ToastGrid from '~c/ToastGrid';

export default {
    name: 'inactiveAnswererPop',
    props: {
        searchChrgUserNo: '',
        searchCorpCd: '',
        searchDeptNm: '',
        searchLoginName: '',
    },
    components: {
        'toast-grid': ToastGrid,
    },
    data() {
        return {
            pageName: 'inactiveAnswererPop',
            pageTitle: '',
            inquiry1Code: '',
            inquiry2Code: '',
            category1Code: '',
            category2Code: '',
            category3Code: '',
            inquiry1CodeList: [],
            inquiry2CodeList: [],
            category1CodeList: [],
            category2CodeList: [],
            category3CodeList: [],
            data: [],
            gridData: [],
            gridKey: 0,
            gridId: 'inactiveAnswererPopGrid',
            options: {
                scrollY: true,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 300,
            },
            pageOptions: {
                useClient: true,
                perPage: Number(localStorage.getItem('listRows')),
            },
            columns: [
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY1'),
                    name: 'INQUIRY_TYPE_NM1',
                    align: 'center',
                    // width: 125,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.INQUIRY2'),
                    name: 'INQUIRY_TYPE_NM2',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY1'),
                    name: 'PRD_CATEGORY_NM1',
                    align: 'center',
                    // width: 75,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY2'),
                    name: 'PRD_CATEGORY_NM2',
                    align: 'center',
                    // width: 375,
                    resizable: true,
                    sortable: false,
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.CATEGORY3'),
                    name: 'PRD_CATEGORY_NM3',
                    align: 'center',
                    // width: 175,
                    resizable: true,
                    sortable: false,
                },
            ],
        };
    },
    watch: {
        inquiry1Code() {
            this.onSearch();
        },
        inquiry2Code() {
            this.onSearch();
        },
        category1Code() {
            this.onSearch();
        },
        category2Code() {
            this.onSearch();
        },
        category3Code() {
            this.onSearch();
        },
    },
    mounted() {
        this.onSearch();
    },
    computed: {
        ...mapGetters({
            corpCd: 'getCorpCd',
            deptLevelCd: 'getDeptLevelCd',
        }),
    },
    methods: {
        async onSearch() {
            SDLUtil.showLoadingBar(true);
            return await axios
                .post(
                    `${SDLUtil.API_URL}/skp/basis/admin/qnaManager/inactiveAnswerer/inactiveAnswerer.skp`,
                    qs.stringify({
                        viewMode: 'Pop',
                        searchChrgUserNo: this.searchChrgUserNo,
                        searchCorpCd: this.searchCorpCd,
                        searchInquiry1: this.inquiry1Code,
                        searchInquiry2: this.inquiry2Code,
                        searchCategory1: this.category1Code,
                        searchCategory2: this.category2Code,
                        searchCategory3: this.category3Code,
                    }),
                )
                .then(resp => {
                    if (0 === this.data.length) {
                        this.data = resp.data.result.rowData;
                        this.inquiryList(1);
                        this.categoryList(1);
                    }
                    this.gridData = resp.data.result.rowData;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        async inquiryList(v) {
            let type = 'inquiryType' + v;
            return await axios
                .post(
                    `${SDLUtil.API_URL}/basis/common/inquiryItem/inquiryItemList.skp`,
                    qs.stringify({
                        type: type,
                        useyn: 'Y',
                        deptLevelCd: this.deptLevelCd,
                        deptNo: this.corpCd,
                        value: this.inquiry1Code,
                    }),
                )
                .then(resp => {
                    if (v === 1) {
                        for (let i = resp.data.result.rowData.length - 1; i > -1; i--) {
                            let code = resp.data.result.rowData[i].CD;
                            const idx = this.data.findIndex(function(item) {
                                return item.INQUIRY_TYPE1 === code;
                            });
                            if (idx === -1) resp.data.result.rowData.splice(i, 1);
                        }
                        this.inquiry1Code = '';
                        this.inquiry2Code = '';
                        this.inquiry1CodeList = resp.data.result.rowData;
                        this.inquiryList(2);
                    } else if (v === 2) {
                        for (let i = resp.data.result.rowData.length - 1; i > -1; i--) {
                            let code = resp.data.result.rowData[i].CD;
                            const idx = this.data.findIndex(function(item) {
                                return item.INQUIRY_TYPE2 === code;
                            });
                            if (idx === -1) resp.data.result.rowData.splice(i, 1);
                        }

                        this.inquiry2Code = '';
                        this.inquiry2CodeList = resp.data.result.rowData;
                    }
                });
        },
        async categoryList(v) {
            let codeCategoryId = '';
            let parentCode = '';
            if (v === 1) {
                codeCategoryId = 'ADM_CATEGORY_A';
                parentCode = '0';
                this.category1Code = '';
                this.category2Code = '';
                this.category3Code = '';
                this.category1CodeList = [];
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    for (let i = resp.length - 1; i > -1; i--) {
                        let code = resp[i].code;
                        const idx = this.data.findIndex(function(item) {
                            return item.PRD_CATEGORY_CD1 === code;
                        });
                        if (idx === -1) resp.splice(i, 1);
                    }
                    this.category1CodeList = resp;
                });
            } else if (v === 2) {
                codeCategoryId = 'ADM_CATEGORY_B';
                parentCode = this.category1Code;
                this.category2Code = '';
                this.category3Code = '';
                this.category2CodeList = [];
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    for (let i = resp.length - 1; i > -1; i--) {
                        let code = resp[i].code;
                        const idx = this.data.findIndex(function(item) {
                            return item.PRD_CATEGORY_CD2 === code;
                        });
                        if (idx === -1) resp.splice(i, 1);
                    }
                    this.category2CodeList = resp;
                });
            } else if (v === 3) {
                codeCategoryId = 'ADM_CATEGORY_C';
                parentCode = this.category2Code;
                this.category3Code = '';
                this.category3CodeList = [];
                await this.getCodeComboList(parentCode, codeCategoryId, this.corpCd).then(resp => {
                    for (let i = resp.length - 1; i > -1; i--) {
                        let code = resp[i].code;
                        const idx = this.data.findIndex(function(item) {
                            return item.PRD_CATEGORY_CD3 === code;
                        });
                        if (idx === -1) resp.splice(i, 1);
                    }
                    this.category3CodeList = resp;
                });
            }
        },
        async getCodeComboList(categoryVal, categoryCode, addCondition) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, addCondition);
            return codeResp;
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/qnaManager/popup/inactiveAnswererPop.vue